module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/109-romania-b2990f13c79a6a3fe71a0526db53b63c.svg";